export default {
  loginBegin(state) {
    state.loading = true;
  },
  loginSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },

  loginErr(state, err) {
    state.loading = false;
    state.error = err;
  },

  logoutBegin(state) {
    state.loading = true;
  },

  logoutSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },
  logoutErr(state, err) {
    state.loading = false;
    state.error = err;
  },
  qrCode(state, link) {
    state.qrCode = link;
  },
  setEmail(state, value) {
    state.email = value;
  },
  setState(state, data) {
    state[data.key] = data.value;
  },
  setJwtToken(state, value) {
    state.jwt_token = value;
  },
  setRoot(state, value) {
    state.is_root = value;
  },
  setUserName(state, value) {
    state.user_name = value;
  },
  setUserSurname(state, value) {
    state.user_surname = value;
  },
  setUserCompany(state, value) {
    state.user_company = value;
  },
};
